import React from "react";
import logo from "../../../assets/images/logo_black.png";
import { Link, useLocation } from "react-router-dom";
import "./PublicVerifiedFooter.css";
import { useSelector } from "react-redux";

const PublicVerifiedFooter = () => {
  const user = useSelector((state) => state?.user);
  return (
    <div className="custom-container">
      <div className="publicVerifiedFooterWrap">
        <div className=" d-flex justify-content-between align-items-end">
          <div>
            <img src={logo} alt="logoImg" width="124px" height="28px" />
          </div>
          <div className="linkedInLink">
            <Link to={`https://www.linkedin.com/company/copyyy-it`}>
              LinkedIn
            </Link>/
            <Link style={{paddingLeft: "5px"}} to={`https://x.com/Copyyyit`}>
              X
            </Link>
          </div>
        </div>
        <div className="publicVerifiedFooterContent" style={{fontSize: "18px",letterSpacing: "0.02.5em"}} >
          <p style={{lineHeight: "1.5"}}>This verification is verified and provided by copyyy.it</p>
          <p style={{lineHeight: "1.4"}}>
            copyyy.it classifies as a software services company, and doesn’t
            fall under the capitulation of a financial institution nor custodian
            of crypto or any other assets.
            <br /> copyyy.it doesn’t trade independently or without consent, but
            enables traders to launch their own copy trading service and verify
            their trades to their community and do so without any interference
            or responsibility towards the outcome.
          </p>
          <div className="verifiedCopyRightPolicy d-flex justify-content-between align-items-md-center align-items-start flex-md-row flex-column-reverse">
            <div>
              <p>© 2022-2024 Copyright by copyyy.it - All rights reserved.</p>
            </div>
            <div className="d-flex align-items-center privacyPolicyLink">
              <Link to={"https://www.copyyy.it/privacy-policies"}>
                Privacy Policy
              </Link>
              <span className="px-1">&</span>
              <Link to={"https://www.copyyy.it/terms-and-conditions"}>
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PublicVerifiedFooter;
